// extracted by mini-css-extract-plugin
export var change = "_3v-1";
export var changeList = "_3v-0";
export var changePath = "_3v-2";
export var diffArrow = "_3v-5";
export var diffRow = "_3v-3";
export var diffValue = "_3v-4";
export var error = "_3v-8";
export var notice = "_3v-9";
export var result = "_3v-6";
export var success = "_3v-7";